interface StatusBadgeProps {
  status: string;
  colors?: Record<string, string>;
  label?: string;
  className?: string;
}

export function StatusBadge({ status, colors, label, className = '' }: StatusBadgeProps) {
  const colorClass = colors?.[status] ?? 'bg-neutral-100 text-neutral-600';
  return (
    <span
      className={`inline-flex max-w-full items-center whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium leading-none ${colorClass} ${className}`}
    >
      {label ?? status.replace(/_/g, ' ')}
    </span>
  );
}
